<template>
  <main class="start">
    <div class="background-map">
      <AnimatedSwissMap />
    </div>

    <section class="content">
      <figure class="urs-welcome urs">
        <img src="../assets/urs_bubble.svg" />
        <figcaption>
          <p>Hi,ich bin Urs!</p>
          <p>
            Damit ich dir persönliche Tips geben kann, verrate mir doch deinen Namen.
          </p>
        </figcaption>
      </figure>

      <form class="name-form">
        <input type="text" name="username" placeholder="Dein Name" class="form-control text-input" autocomplete="off">
        <router-link to="/destination" tag="button" class="form-control button-primary"><img src="../assets/icons/arrow_forward.svg" /></router-link>
      </form>
    </section>

  </main>
</template>

<script>
import AnimatedSwissMap from '@/components/AnimatedSwissMap.vue';

export default {
  name: 'start',
  components: {
    AnimatedSwissMap,
  },
};
</script>

<style lang="scss">
$headerLogoHeight: 60px;
$headerPadding: 15px;
$footer-height: 70px;

.start{
  position: relative;
  // min-height: calc(100vh - #{$headerLogoHeight + 2 * $headerPadding} - #{$footer-height});
  display:flex;
  justify-content: center;
  align-items:center;

  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width:100%;

    .name-form{
      display: flex;
      align-items: stretch;
      width: calc(100% - 30px);
      max-width: 450px;
      z-index: 102;

      input[type="text"]{
        margin-right:10px;
      }
    }

    .urs-welcome{
      position: absolute;
      display: block;
      bottom: -110px;
      left: 45%;
      z-index: 101;
      animation-name: 'urs-welcome';
      animation-iteration-count: infinite;
      animation-direction: alternate;
      animation-duration:1.5s;
      animation-timing-function: ease-in-out;
      transform-origin: 75% 100%;

      img{
        display: block;
        height: 460px;
      }

      figcaption{
        position: absolute;
        top: 0;
        width: 53%;
        left: 0;
        bottom: 63%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 27px;
        border-radius: 53%;
        flex-direction: column;
        text-align: center;

        p:not(:last-child){
          margin-bottom:5px;
        }
      }

      @keyframes urs-welcome {
        from {
          transform: rotate(0);
        }

        to {
          transform: rotate(1.5deg);
        }
      }
    }
  }
  .background-map{
    position: absolute;
    z-index: -1;
    top:0;
    left:0;
    right:0;
    bottom:0;
    display: flex;
    justify-content: center;
    align-items: center;

    svg{
      width: calc(100% - 30px);
      height: calc(100% - 30px);
      display:block;
      opacity: 0.5;
    }
  }
}

.footer{
  // margin-top: 0;
}
</style>
